import { render, staticRenderFns } from "./PaginaInLucru.vue?vue&type=template&id=21be488a&scoped=true&"
import script from "./PaginaInLucru.vue?vue&type=script&lang=js&"
export * from "./PaginaInLucru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21be488a",
  null
  
)

export default component.exports